import e, { Suspense as u, useMemo as l } from "react";
const r = e.createContext(null);
function a({
  children: n,
  ctx: t
}) {
  const o = l(() => t, [t]);
  return /* @__PURE__ */ e.createElement(r.Provider, { value: o }, n);
}
function i(n, t) {
  return /* @__PURE__ */ e.createElement(a, { ctx: t }, /* @__PURE__ */ e.createElement(u, { fallback: null }, /* @__PURE__ */ e.createElement(n, null)));
}
function s() {
  return e.useContext(r);
}
export {
  a as PageSettingsProvider,
  i as providePage,
  s as usePageSettings
};
//# sourceMappingURL=pageSettingsProvider.js.map
